export const TOP_CITIES_TITLE = `Find opportunities in the following locations:`

export const TITLE_1 = `SF Bay Area`
export const TITLE_2 = `New York Metro`
export const TITLE_3 = `Los Angeles`
export const TITLE_4 = `Toronto`
export const TITLE_5 = `Chicago`
export const TITLE_6 = `Seattle`
export const TITLE_7 = `Austin`
export const TITLE_8 = `Vancouver`

export const SLUG_1 = `sf-bay-area-ca`
export const SLUG_2 = `new-york-metro-ny`
export const SLUG_3 = `los-angeles-ca`
export const SLUG_4 = `toronto-on`
export const SLUG_5 = `chicago-il`
export const SLUG_6 = `seattle-wa`
export const SLUG_7 = `austin-tx`
export const SLUG_8 = `vancouver-bc`
